import { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import * as reportApi from '../api/PomReport';
import { IPomReportCategoryData, IPomReportCategorySumItem, IPomReportDataCategory, IPomReportDataInfo, REPORTSTATUS } from '../util/DataModelInterface'
import { Spinner } from '../components/Spinner';
import { ToastWrap } from '../components/ToastWrap';
import { statusView } from '../components/CommonControls';
import { useLocation, useNavigate } from 'react-router-dom';
import { PomList } from '../components/PomList';
import useToastHandler from '../hooks/useToastHandler';
import { getDeadline } from '../util/FormatDateUtil';

export const ReportAdmin = () => {
    const intl = useIntl();
    const navigate = useNavigate();
    const { state } = useLocation();
    const { addToast } = useToastHandler();

    const [categories, setCategories] = useState([] as IPomReportCategoryData[]);
    const [reportData, setReportData] = useState({} as IPomReportDataCategory);
    const [reportInfoData, setReportInfoData] = useState({} as IPomReportDataInfo);
    const [reportCatSumData, setReportCatSumData] = useState({} as {[x: string]: IPomReportCategorySumItem});
    const [loading, setLoading] = useState(false);
    const [toastActive, setToastActive] = useState(false);
    const [toastHeader, setToastHeader] = useState("");
    const [toastText, setToastText] = useState("");
    const [toastType, setToastType] = useState("");
    const [reference, setReference] = useState("");
    const [reportStatus, setReportStatus] = useState(state.status);
    const [confirmingPage, setConfirmingPage] = useState(state.confirm);
    const [period, ] = useState(state.period);
    const [companyId, ] = useState(state.companyId);
    const [companyName, ] = useState(state.companyName);
    const [errorText, setErrorText] = useState("");

    const year = period.split("-")[0];
    const month = period.split("-")[1];
    const timePeriod = month + "/" + year;

    useEffect(() => {
        setErrorText("");

        const fetchDataAsync = async () => {
            try {
                setLoading(true);
                const data1 = await reportApi.getReport(companyId, period);
                console.log("Pom repor[t" + period + "] - data: " + JSON.stringify(data1));
                if (data1?.result) {
                    setReportData(data1.result.categories);
                    setReportInfoData(data1.result.info);
                    setReportCatSumData(data1.result.catSums);
                    setReference(data1.result.info ? data1.result.info.reference : "");
                    setReportStatus(data1.result.info ? data1.result.info.status : "Missing");
                }
                else if (data1?.error) {
                  addToast(data1.error, 'reports', 'fetch');
                  setErrorText(data1.error.value);
              }

                const data2 = await reportApi.getCategories();
                // console.log("Pom categories - data", data2);
                if (data2?.error) {
                  addToast(data2.error, 'reports', 'fetch');
                  setErrorText(data2.error.value);
                } else if (data2) {
                  setCategories(data2);
                }
                setLoading(false);
                setToastActive(false);
            } catch (error) {
                return error;
            }
          }
        fetchDataAsync();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companyId, period]);

    const showConfirmButton = () => {
      if (confirmingPage) {
          return false;
      } else if (reportStatus === REPORTSTATUS.ONGOING || reportStatus === REPORTSTATUS.REOPENED) {
          return true;
      } else {
          return false;
      }
    }

    const startConfirmReportAdmin = async () => {
      setConfirmingPage(true);
    }

    const confirmReport = () => {
        setLoading(true);
        let newStatus = reportStatus === REPORTSTATUS.ONGOING ? REPORTSTATUS.CONFIRMED : REPORTSTATUS.CORRECTED;
        reportApi.setReportStatus(reportInfoData.report_id, newStatus, "").then((data: any) => {
            // console.log("setReportStatus ADMIN [" + reportInfoData.report_id + "] - response: " + JSON.stringify(response));
            if (data?.error) {
              addToast(data.error, 'reports', 'confirm');
            } else {
              setReportStatus(newStatus);
              setConfirmingPage(false);
              setToastHeader(intl.formatMessage({id: 'report.confirmed'}));
              setToastText("");
              setToastType('success');
              setToastActive(true);
            }
          }).finally(() => {
            setLoading(false);
          });
    }

    return (
        <>
        <Spinner active={loading} />
        <ToastWrap active={toastActive} heading={toastHeader} text={toastText} type={toastType} setActive={(active: boolean) => setToastActive(active)} />
        { !errorText &&
        <div id="reportinfo">
            <Form action="#" id="reportForm">

              <div className="action-buttons py-4 d-flex flex-row align-items-start">
                <div className="page-header">
                  {/* <h1><FormattedMessage id="report.header"/></h1> */}
                  <h1>{companyName} - {timePeriod}</h1>
                  <p className="info"><i className="fa fa-info-circle me-2"></i><FormattedMessage id="report.header.info"/></p>
                </div>

                <div className="ms-auto d-flex flex-row align-items-center">
                  <p className="state me-4 m-0">
                    {
                        statusView(reportStatus, getDeadline(new Date(period)) )
                    }
                  </p>
                  <button type="button" className="btn btn-secondary" onClick={() => { navigate(-1); }}>
                    <i className="fa fa-close me-2"></i>
                    <FormattedMessage id="button.close"/>
                  </button>
                  { showConfirmButton() &&
                    <button type="button" className="btn btn-primary btn-submit" onClick={() => startConfirmReportAdmin()}>
                      <i className="fa fa-check me-2"></i>
                      <FormattedMessage id="button.report.confirm"/>
                    </button>
                  }
                </div>

              </div>


              <div className="highlight_bg">

              { confirmingPage && <div className="alert alert-warning" role="alert">
                  <div className="d-flex flex-row">
                    <i className="fa fa-info-circle me-2"></i>
                    <div>
                      <p><FormattedMessage id="report.header.confirm.text"/></p>
                      <button type="button" className="btn btn-primary btn-confirm my-4" onClick={() => confirmReport()}>
                        <i className="fa fa-check me-2"></i>
                        <FormattedMessage id="report.header.confirm"/>
                      </button>
                    </div>
                  </div>
                </div>}

                <p className="details-info">
                  <span className="key"><FormattedMessage id="report.header.reporter"/></span>
                  <span className="value">{reportInfoData.name}</span>
                </p>

                <p className="details-info">
                  <span className="key"><FormattedMessage id="report.header.modified"/></span>
                  <span className="value senddate">{reportInfoData.modified && reportInfoData.modified.replace(/T|[.].+/g, " ")}</span>
                </p>

                <p className="details-info">
                  <span className="key"><FormattedMessage id="report.header.period"/></span>
                  <span className="value reportperiod">{timePeriod}</span>
                </p>

                <p className="details-info">
                  <span className="key"><FormattedMessage id="report.reference"/></span>
                  <span className="value reportperiod">{reference}</span>
                </p>

                { categories && categories.length > 0 &&
                    <PomList
                        categories={categories}
                        reportData={reportData}
                        reportInfoData={reportInfoData}
                        reportCatSumData={reportCatSumData}
                        period={period}
                        companyName={companyName}
                    />
                }

              </div>
            </Form>
        </div>
        }
        { errorText &&
            <div id="reportinfo">
                {errorText}
            </div> }
        </>
    );
};